module.exports = __webpack_public_path__ + "img/estalagem02.a02be5c0.jpg";